export const PROMPT_P08 = (sponsorProduct = 'Sika Antisol-E + SikaLatex') => `
Analyze for PLASTIC SHRINKAGE CRACKING (ACI 305R, ACI 308R).
Visual: parallel cracks 45° or random shallow (depth <25mm), spacing 0.3–1.0m,
no relation to rebar. Distinguish from settlement cracking and drying shrinkage.
Return ONLY this JSON:
{
  "pathology_id": "p08_plastic_shrinkage",
  "pathology_name": { "es": "Retracción plástica", "en": "Plastic shrinkage cracking" },
  "norm": "ACI 305R / ACI 308R",
  "confidence": 80,
  "requires_additional_input": false,
  "crack_pattern": "parallel_diagonal|random_surface|map_cracking|settlement",
  "crack_spacing": "<30cm|30-100cm|>100cm|irregular",
  "probable_age_at_cracking": "hours_fresh|days_young|weeks_curing|months_old|unknown",
  "root_cause": { "es": "Típico: temperatura alta + viento + baja H.R. + curado insuficiente", "en": "Typical: high temp + wind + low RH + inadequate curing" },
  "severity": "low|medium|high|critical",
  "urgency": "deferred|planned|immediate|emergency",
  "repair": {
    "procedure": {
      "es": ["1. Si concreto aún plástico: recerrar grietas con retallado + revibrado inmediato","2. Si endurecido y grietas <1mm: lechada cemento + silicato o mortero epóxico","3. Si grietas >1mm: inyección resina epóxica o PU expansivo","4. Aplicar membrana de curado + curado húmedo compensatorio 7 días"],
      "en": ["1. If still plastic: immediately close cracks by re-striking + revibrating","2. If hardened and cracks <1mm: cement+silicate slurry or epoxy mortar","3. If cracks >1mm: epoxy resin or expansive PU injection","4. Apply curing membrane + compensatory wet curing 7 days"]
    },
    "norm_reference": "ACI 305R-10 (hot weather); ACI 308R-16 (curing)"
  },
  "materials": {
    "generic": { "es": "Compuesto de curado ASTM C309; mortero relleno fisuras", "en": "Curing compound ASTM C309; crack-filling mortar" },
    "premium": { "product": "${sponsorProduct}", "brand": "Sika", "note": { "es": "Sika Antisol-E cumple ASTM C309 Tipo 1", "en": "Sika Antisol-E complies ASTM C309 Type 1" } }
  },
  "linkedin_draft": { "es": "..." },
  "disclaimer": { "es": "Retracción plástica indica deficiencia constructiva. Auditoría de protocolo de colado y curado recomendada.", "en": "Plastic shrinkage indicates a construction process deficiency. Placement and curing audit recommended." }
}`;
